import React, { useState } from 'react';
import { LogoFull } from './Logo';
import { signOut } from '../lib/auth';
import { forgetSignIn } from '../lib/signInMemory';
import { clearViewAs } from '../lib/viewAs';
import './AccessSwitchedOff.css';

/**
 * What a person an administrator has switched off sees, instead of Jarvis.
 *
 * Deliberately not the sign-in page and not a redirect to it: they ARE signed
 * in, as far as Microsoft is concerned, and offering to sign them in again
 * would only go round in a circle. One sentence saying what happened and who
 * to ask, and a way to sign out - which also forgets this device's
 * "Continue as" (lib/signInMemory), so the next person at the machine is not
 * greeted by their name.
 */
export default function AccessSwitchedOff() {
  const [busy, setBusy] = useState(false);
  const leave = async () => {
    setBusy(true);
    forgetSignIn();
    try { clearViewAs(); } catch { /* nothing stored */ }
    try {
      await signOut();
    } catch {
      // Microsoft could not be reached: forgotten here at least, and the
      // front door is where a signed-out person belongs.
      window.location.assign('/login');
    }
  };
  return (
    <main className="switched-off" data-switched-off="">
      <div className="switched-off-card" role="alert">
        <div className="switched-off-brand"><LogoFull height={48} /></div>
        <h1>Your access to Jarvis has been switched off.</h1>
        <p>If you think this is a mistake, contact your IT administrator.</p>
        <button type="button" className="btn btn-primary switched-off-out"
                onClick={leave} disabled={busy}>
          {busy ? 'Signing out…' : 'Sign out'}
        </button>
      </div>
    </main>
  );
}
